import * as React from 'react'
import { useActivitySummaryContext } from '../../../context'
import { closeActivitySummaryActionCreator as close } from '../../../state'

export function useHandlers() {
  const [{ open }, dispatch] = useActivitySummaryContext()

  const onClose = React.useCallback(() => dispatch(close()), [dispatch])

  return {
    open,
    onClose,
  }
}
